<template>
  <div class="feature-wrap style-two ptb-100">
    <div class="container">
      <div class="row align-items-center">
        <div
          class="col-lg-6"
          data-aos="fade-in"
          data-aos-duration="1200"
          data-aos-delay="200"
        >
          <div class="feature-content">
            <div class="content-title style-one">
              <h6 class="section-subtitle">
                Investment <span>Highlights</span>
              </h6>
              <h2>Why Invest in Guac & Grill</h2>
              <p>
                The halal food market's rapid growth at a 9% CAGR through 2029, combined with strong demand in the NYC metro area and suburbs like Nassau County, positions Guac & Grill to capture a promising niche.
              </p>
            </div>
            <ul class="feature-list list-style">
              <li>Rapidly Growing Market with Low Competition</li>
              <li>Attractive Franchise Economics and Support</li>
              <li>First-Mover Advantages in Underserved Markets</li>
            </ul>
          </div>
        </div>
        <div
          class="col-lg-6 pe-xxl-0"
          data-aos="fade-in"
          data-aos-duration="1200"
          data-aos-delay="400"
        >
          <div class="feature-img-wrap">
            <div class="feature-img">
              <img src="https://images.pexels.com/photos/1640774/pexels-photo-1640774.jpeg?auto=compress&cs=tinysrgb&w=600&h=400&fit=crop" alt="Mexican Restaurant Franchise" />
            </div>
            <div class="counter-card-wrap">
              <div class="counter-card">
                <div class="counter-num">
                  <h4 class="counter">9</h4>
                  <span>%</span>
                </div>
                <p><b>CAGR</b> halal food market growth</p>
              </div>
              <div class="counter-card">
                <div class="counter-num">
                  <h4 class="counter">1.39</h4>
                  <span>M</span>
                </div>
                <p><b>Residents</b> in target market</p>
              </div>
              <div class="counter-card">
                <div class="counter-num">
                  <h4 class="counter">$143</h4>
                  <span>K</span>
                </div>
                <p><b>Median</b> household income</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "FranchiseBenefits",
});
</script>

<style lang="scss" scoped>
.feature-wrap {
  &.style-two {
    background: linear-gradient(135deg, #1f2937 0%, #374151 100%);
    .feature-content {
      .content-title {
        h2 {
          font-weight: 700;
          color: #b5ff00;
        }
        h6 {
          color: #d1d5db;
          span {
            color: #9ca3af;
          }
        }
        p {
          color: #d1d5db;
        }
      }
      .feature-list {
        margin: 28px 0 0;
        li {
          background: linear-gradient(135deg, #374151 0%, #4b5563 100%);
          color: #ffffff;
          font-size: 18px;
          font-weight: 500;
          position: relative;
          padding: 19px 20px 19px 62px;
          margin-bottom: 15px;
          border-radius: 10px;
          border: 1px solid rgba(255, 255, 255, 0.1);
          &:last-child {
            margin-bottom: 0;
          }
          &:before {
            position: absolute;
            top: 26px;
            left: 30px;
            content: "";
            width: 12px;
            height: 12px;
            background-color: #6b7280;
            border-radius: 50%;
          }
        }
      }
    }
    .feature-img-wrap {
      position: relative;
      .feature-img {
        border-radius: 20px;
        display: block;
        margin-left: auto;
        img {
          display: block;
          margin-left: auto;
          border-radius: 20px;
        }
      }
      .counter-card-wrap {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: space-between;
        background-color: var(--medical_titleColor);
        border-radius: 5px;
        position: absolute;
        bottom: 35px;
        left: 0;
        max-width: 535px;
        z-index: 1;
        padding: 30px 35px 20px 35px;
        border-radius: 30px 0px 30px 30px;
        background: linear-gradient(135deg, #4b5563 0%, #6b7280 100%);
        border: 1px solid rgba(255, 255, 255, 0.1);
        &:before {
          position: absolute;
          top: -5px;
          left: -5px;
          width: calc(100% + 10px);
          height: calc(100% + 10px);
          content: "";
          border: 1px solid rgba(255, 255, 255, 0.1);
          border-radius: 30px 0px 30px 30px;
        }
        .counter-card {
          width: 33.33%;
          position: relative;
          margin-bottom: 15px;
          .counter-num {
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            .counter,
            span {
              font-size: 40px;
              line-height: 40px;
              font-weight: 600;
              margin: 0;
              letter-spacing: -1.6px;
              color: #ffffff;
              position: relative;
            }
          }
          p {
            font-size: 14px;
            line-height: 20px;
            margin: 7px 0 0;
            b {
              color: #ffffff;
              font-weight: 700;
            }
            color: #d1d5db;
          }
          &:nth-child(1) {
            padding-right: 25px;
          }
          &:nth-child(2) {
            padding-left: 10px;
            padding-right: 25px;
          }
          &:nth-child(3) {
            padding-left: 18px;
            padding-right: 10px;
          }
        }
      }
    }
  }
}
</style>
